<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="(showGetrankeStand = true) && (neuZahlung = true) && (zahlung = neueZahlung)" v-on="on"
            ><v-icon>add</v-icon></v-btn
          >
        </template>
        <span>Zählen</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon disabled v-on="on"><v-icon>save_alt</v-icon></v-btn>
        </template>
        <span>Exportieren</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon disabled v-on="on"><v-icon>delete</v-icon></v-btn>
        </template>
        <span>Löschen</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Suchen"
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>

    <v-row class="ma-0">
      <v-col cols="12">
        <v-card outlined>
          <v-tabs v-model="tabs" center-active centered>
            <v-tab v-for="(getrankestand, jahr) in getrankestande" :key="jahr">{{ jahr }}</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tabs">
            <v-tab-item v-for="(getrankestand, jahr) in getrankestande" :key="jahr">
              <v-data-table
                height="calc(100vh - 240px)"
                dense
                :headers="headers"
                :items="getrankestand"
                :search="search"
                fixed-header
                hide-default-footer
                :items-per-page="-1"
                :hide-default-header="hideHeader"
                no-data-text="Keine Zählungen vorhanden"
              >
                <template v-slot:header="{ item }">
                  <tr class="hidden-sm-and-up">
                    <th>Datum</th>
                    <th>Betrag</th>
                    <th></th>
                  </tr>
                </template>
                <template v-slot:item="{ item }">
                  <tr v-on:dblclick="(zahlung = item) && (showGetrankeStand = true) && (neueZahlung = false)">
                    <td>{{ $filters.date(item.datum, "DD.MM.YYYY") }}</td>
                    <td class="hidden-xs-only" v-if="item.zahler">{{ $filters.user(item.zahler, bbrbbr) }}</td>
                    <td class="hidden-xs-only" v-else></td>
                    <td>{{ item.volumen.toFixed(1) }} l</td>
                    <td>{{ item.gesamt | money }}</td>
                    <td width="20px" class="pl-0 pr-2">
                      <v-btn
                        icon
                        @click="
                          (zahlung = item) &&
                            (positionen = item.positionen) &&
                            (positionenPfand = item.positionenPfand) &&
                            (showGetrankeStand = true) &&
                            (neueZahlung = false)
                        "
                        ><v-icon>edit</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showGetrankeStand" fullscreen persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        <v-card-title class="primary white--text">
          <div v-if="neueZahlung">Neue Getränkezählung erstellen</div>
          <div v-else>Zählung vom {{ $filters.date(zahlung.datum, "DD.MM.YYYY") }}</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="showGetrankeStand = false"><v-icon class="white--text">close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 ma-0">
          <v-toolbar dense flat>
            <v-spacer></v-spacer>
            <v-btn icon @click="updateDate(-1)"><v-icon>keyboard_arrow_left</v-icon></v-btn>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-left="65"
              :nudge-bottom="10"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on"
                  ><span class="title">{{ $filters.date(zahlung.datum, "DD.MM.YYYY") }}</span></v-btn
                >
              </template>
              <v-date-picker
                no-title
                scrollable
                prev-icon="keyboard_arrow_left"
                next-icon="keyboard_arrow_right"
                v-model="zahlung.datum"
                @input="menu = false"
                locale="de-de"
              ></v-date-picker>
            </v-menu>
            <v-btn icon @click="updateDate(1)"><v-icon>keyboard_arrow_right</v-icon></v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>
          <v-row class="pa-0 ma-0">
            <v-col cols="4" md="2" offset-md="2">
              <v-card class="text-center py-2" outlined>
                <div class="subtitle-2">Summe</div>
                <div class="title">{{ summe | money }}</div>
              </v-card>
            </v-col>
            <v-col cols="4" md="2">
              <v-card class="text-center py-2" outlined>
                <div class="subtitle-2">Pfand</div>
                <div class="title">{{ summePfand | money }}</div>
              </v-card>
            </v-col>
            <v-col cols="4" md="2">
              <v-card class="text-center py-2" outlined>
                <div class="subtitle-2">MwSt.</div>
                <div class="title">{{ summeMwst | money }}</div>
              </v-card>
            </v-col>
            <v-col cols="4" md="2">
              <v-card class="text-center py-2" outlined>
                <div class="subtitle-2">Gesamt</div>
                <div class="title">{{ summeGesamt | money }}</div>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="py-1">
                  Getränke
                  <v-spacer></v-spacer>
                  <v-btn small class="primary" @click="(showSpeedInsert = true) && calcTabelleGetranke()"
                    ><v-icon class="pr-2">speed</v-icon>Speedeingabe</v-btn
                  >
                </v-card-title>
                <v-divider></v-divider>
                <v-row class="ma-0">
                  <v-col cols="7">
                    <v-autocomplete
                      hide-details
                      dense
                      outlined
                      label="Getränk"
                      :items="getranke"
                      v-model="getrank"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      append-outer-icon="plus_one"
                      prepend-icon="exposure_neg_1"
                      @click:append-outer="anzahlGetrank++"
                      @click:prepend="anzahlGetrank > 0 ? anzahlGetrank-- : ''"
                      hide-details
                      dense
                      outlined
                      type="number"
                      min="0"
                      :value="anzahlGetrank"
                      v-model="anzahlGetrank"
                      label="Anzahl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-btn dark class="primary" @click="addGetrank"><v-icon>playlist_add</v-icon></v-btn>
                  </v-col>
                </v-row>
                <v-simple-table dense fixed-header height="calc(100vh - 400px)">
                  <thead>
                    <tr>
                      <th>Bezeichnung</th>
                      <th>Anzahl</th>
                      <th>Netto</th>
                      <th>Summe</th>
                      <th width="20px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in zahlung.positionen" :key="item.name">
                      <td>{{ item.bezeichnung }}</td>
                      <td>{{ item.anzahl }}</td>
                      <td>{{ item.netto | money }}</td>
                      <td>{{ item.summe | money }}</td>
                      <td>
                        <v-btn icon @click="delGetrank(item)"><v-icon>delete</v-icon></v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="py-1">Pfand</v-card-title>
                <v-divider></v-divider>
                <v-row class="ma-0">
                  <v-col cols="7">
                    <v-autocomplete
                      hide-details
                      dense
                      outlined
                      label="Getränk"
                      :items="getranke"
                      v-model="pfand"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      append-outer-icon="plus_one"
                      prepend-icon="exposure_neg_1"
                      @click:append-outer="anzahlPfand++"
                      @click:prepend="anzahlPfand > 0 ? anzahlPfand-- : ''"
                      hide-details
                      dense
                      outlined
                      type="number"
                      min="0"
                      :value="anzahlPfand"
                      v-model="anzahlPfand"
                      label="Anzahl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-btn dark class="primary" @click="addPfand"><v-icon>playlist_add</v-icon></v-btn>
                  </v-col>
                </v-row>
                <v-simple-table dense fixed-header height="calc(100vh - 400px)">
                  <thead>
                    <tr>
                      <th>Bezeichnung</th>
                      <th>Anzahl</th>
                      <th>Pfand</th>
                      <th width="20px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in zahlung.positionenPfand" :key="item.name">
                      <td>{{ item.bezeichnung }}</td>
                      <td>{{ item.anzahl }}</td>
                      <td>{{ item.pfand | money }}</td>
                      <td>
                        <v-btn icon @click="delPfand(item)"><v-icon>delete</v-icon></v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn icon v-if="!neuZahlung" @click="showDeleteZahlung = true" v-on="on"><v-icon>delete</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="showGetrankeStand = false">Abbrechen</v-btn>
          <v-btn v-if="neueZahlung" class="primary" text @click="saveZahlung()">Speichern</v-btn>
          <v-btn v-else class="primary" text @click="updateZahlung()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogDelete
      :visible.sync="showDeleteZahlung"
      title="Zählung löschen"
      message="Willst du diese Zählung wirklich löschen?"
      abbrechen="Abbrechen"
      weiter="Löschen"
      @closeTrue="deleteZahlung()"
      @closeFalse="showDeleteZahlung = false"
    >
    </dialogDelete>

    <v-dialog v-model="showSpeedInsert" width="90%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title>
          Getränke hinzufügen
          <v-spacer></v-spacer>
          <v-btn icon @click="showSpeedInsert = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0 ma-0">
          <v-row no-gutters>
            <v-col cols="3">
              <v-list dense>
                <draggable v-model="tabelleGetranke[0]" @change="savereihenfolge" group="myGroup">
                  <v-list-item class="py-0 px-1" v-for="(item, index) in tabelleGetranke[0]" :key="index">
                    <v-list-item-action class="my-0"
                      ><v-icon class="grey--text">drag_indicator</v-icon></v-list-item-action
                    >
                    <v-list-item-content class="my-0">
                      <v-list-item-title>{{ item.bezeichnung }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                      <v-responsive max-width="50" class="pt-1 mr-4">
                        <v-text-field
                          v-model="item.anzahl"
                          dense
                          hide-details
                          label="0"
                          single-line
                          outlined
                          :rules="[rules.number]"
                        ></v-text-field>
                      </v-responsive>
                    </v-list-item-action>
                  </v-list-item>
                </draggable>
              </v-list>
            </v-col>
            <v-col cols="3">
              <v-list dense>
                <draggable v-model="tabelleGetranke[1]" @change="savereihenfolge" group="myGroup">
                  <v-list-item class="py-0 px-1" v-for="(item, index) in tabelleGetranke[1]" :key="index">
                    <v-list-item-action class="my-0"
                      ><v-icon class="grey--text">drag_indicator</v-icon></v-list-item-action
                    >
                    <v-list-item-content class="my-0">
                      <v-list-item-title>{{ item.bezeichnung }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                      <v-responsive max-width="50" class="pt-1 mr-4">
                        <v-text-field
                          v-model="item.anzahl"
                          dense
                          hide-details
                          label="0"
                          single-line
                          outlined
                          :rules="[rules.number]"
                        ></v-text-field>
                      </v-responsive>
                    </v-list-item-action>
                  </v-list-item>
                </draggable>
              </v-list>
            </v-col>
            <v-col cols="3">
              <v-list dense>
                <draggable v-model="tabelleGetranke[2]" @change="savereihenfolge" group="myGroup">
                  <v-list-item class="py-0 px-1" v-for="(item, index) in tabelleGetranke[2]" :key="index">
                    <v-list-item-action class="my-0"
                      ><v-icon class="grey--text">drag_indicator</v-icon></v-list-item-action
                    >
                    <v-list-item-content class="my-0">
                      <v-list-item-title>{{ item.bezeichnung }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                      <v-responsive max-width="50" class="pt-1 mr-4">
                        <v-text-field
                          v-model="item.anzahl"
                          dense
                          hide-details
                          label="0"
                          single-line
                          outlined
                          :rules="[rules.number]"
                        ></v-text-field>
                      </v-responsive>
                    </v-list-item-action>
                  </v-list-item>
                </draggable>
              </v-list>
            </v-col>
            <v-col cols="3">
              <v-list dense>
                <draggable v-model="tabelleGetranke[3]" @change="savereihenfolge" group="myGroup">
                  <v-list-item class="py-0 px-1" v-for="(item, index) in tabelleGetranke[3]" :key="index">
                    <v-list-item-action class="my-0"
                      ><v-icon class="grey--text">drag_indicator</v-icon></v-list-item-action
                    >
                    <v-list-item-content class="my-0">
                      <v-list-item-title>{{ item.bezeichnung }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                      <v-responsive max-width="50" class="pt-1 mr-4">
                        <v-text-field
                          v-model="item.anzahl"
                          dense
                          hide-details
                          label="0"
                          single-line
                          outlined
                          :rules="[rules.number]"
                        ></v-text-field>
                      </v-responsive>
                    </v-list-item-action>
                  </v-list-item>
                </draggable>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="showSpeedInsert = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="insertGertranke()" dark text>speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import draggable from "vuedraggable";
  export default {
    props: ["on"],
    components: {
      draggable,
    },
    data() {
      return {
        anzahlGetrank: 0,
        anzahlPfand: 0,
        getrank: "",
        getranke_zahlen: [],
        headers: [
          { text: "Datum", align: "left", value: "datum" },
          { text: "Gezählt von", value: "zahler" },
          { text: "Volumen", value: "volumen" },
          { text: "Wert", value: "gesamt" },
          { text: "", sortable: false, value: "" },
        ],
        headersTabelleGetranke: [
          { text: "", align: "left", value: "nummer" },
          { text: "Bezeichnung", align: "left", value: "bezeichnung" },
          { text: "Anzahl", align: "left", value: "anzahl" },
        ],
        menu: false,
        neueZahlung: {
          datum: new Date().toISOString().substr(0, 10),
          rechnungsnummer: "",
          positionen: [],
          positionenPfand: [],
          rabatt: 0,
          zahlungsdatum: "",
        },
        neuZahlung: false,
        pfand: "",
        tabs: 0,
        search: "",
        selected: [],
        showDeleteZahlung: false,
        showGetrankeStand: false,
        showSpeedInsert: false,
        zahlung: {},
        tabelleGetranke: [],
        rules: {
          number: (value) => {
            const pattern = /^[0-9]*$/;
            return pattern.test(value) || "Nur Zahlen erlaubt";
          },
        },
      };
    },
    computed: {
      currentBbr() {
        return this.$getCurrentBbr();
      },
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      getrankestande() {
        if (this.$store.state.getrankeStand.getrankeStande.length === 0) {
          this.$store.dispatch("getrankeStand/loadGetrankeStande");
        }
        let zahlungen = this.$store.state.getrankeStand.getrankeStande;
        zahlungen.forEach((zahlung) => {
          zahlung.jahr = zahlung.datum.split("-")[0];
          zahlung.volumen = 0;
          zahlung.positionen.forEach((pos) => {
            let getrank = this.$store.getters["getranke/getrank"](pos.id);
            zahlung.volumen += pos.anzahl * getrank.volumen;
          });
        });
        const key = "jahr";
        const result = {};
        let tabs = 0;
        zahlungen.forEach((item) => {
          if (!result[item[key]]) {
            result[item[key]] = [];
            tabs++;
          }
          result[item[key]].push(item);
        });
        this.tabs = tabs - 1;
        return result;
      },
      hideHeader() {
        return this.$vuetify.breakpoint.name === "xs";
      },
      getranke() {
        let getranke = [];
        if (this.$store.state.getranke.getranke.length === 0) {
          this.$store.dispatch("getranke/loadGetranke");
        }
        let alleGetranke = [];
        this.$store.state.getranke.getranke.forEach((item) => {
          if (item.switchZahlung) {
            alleGetranke.push(item);
          }
        });
        alleGetranke = alleGetranke.sort(function (a, b) {
          return a.nummer - b.nummer;
        });
        alleGetranke.forEach((item) => {
          getranke.push({
            id: item.id,
            text: item.bezeichnung,
            nummer: item.nummer,
            value: {
              item: item,
              id: item.id,
            },
          });
        });
        return getranke;
      },
      summe() {
        let summe = 0;
        if (this.zahlung.positionen) {
          this.zahlung.positionen.forEach((position) => {
            summe = summe + parseFloat(position.summe);
          });
        }
        return summe;
      },
      summePfand() {
        let summe = 0;
        if (this.zahlung.positionen) {
          this.zahlung.positionen.forEach((position) => {
            summe = summe + parseFloat(position.pfand);
          });
        }
        if (this.zahlung.positionenPfand) {
          this.zahlung.positionenPfand.forEach((position) => {
            summe = summe + parseFloat(position.pfand);
          });
        }
        return summe;
      },
      summeMwst() {
        return parseFloat(((parseFloat(this.summe) + parseFloat(this.summePfand)) * 0.19).toFixed(2));
      },
      summeGesamt() {
        return (parseFloat(this.summe) + parseFloat(this.summePfand) + parseFloat(this.summeMwst)).toFixed(2);
      },
    },
    methods: {
      delGetrank(item) {
        this.zahlung.positionen.splice(this.zahlung.positionen.indexOf(item), 1);
      },
      delPfand(item) {
        this.zahlung.positionenPfand.splice(this.zahlung.positionenPfand.indexOf(item), 1);
      },
      addGetrank() {
        this.zahlung.positionen.push({
          id: this.getrank.id,
          bezeichnung: this.getrank.item.bezeichnung,
          anzahl: this.anzahlGetrank,
          netto: (this.getrank.item.preis / this.getrank.item.verkaufseinheit / 1.19).toFixed(2),
          pfand: ((this.getrank.item.pfand * this.anzahlGetrank) / this.getrank.item.verkaufseinheit).toFixed(2),
          summe: ((this.getrank.item.preis / this.getrank.item.verkaufseinheit / 1.19) * this.anzahlGetrank).toFixed(2),
        });
        this.getrank = "";
        this.anzahlGetrank = 0;
      },
      addPfand() {
        this.zahlung.positionenPfand.push({
          id: this.pfand.id,
          bezeichnung: this.pfand.item.bezeichnung,
          anzahl: this.anzahlPfand,
          pfand: this.pfand.item.pfand * this.anzahlPfand,
        });
        this.pfand = "";
        this.anzahlPfand = "";
      },
      updateDate(value) {
        this.zahlung.datum = new Date(this.zahlung.datum);
        this.zahlung.datum = new Date(this.zahlung.datum.setDate(this.zahlung.datum.getDate() + value))
          .toISOString()
          .substr(0, 10);
      },
      updateZahlung() {
        this.zahlung.betrag = this.summe;
        this.zahlung.pfand = this.summePfand;
        this.zahlung.mwst = this.summeMwst;
        this.zahlung.gesamt = this.summeGesamt;
        this.$store.dispatch("getrankeStand/updateGetrankeStandData", this.zahlung);
        this.showGetrankeStand = false;
        this.zahlung = [];
      },
      saveZahlung() {
        this.zahlung.betrag = this.summe;
        this.zahlung.pfand = this.summePfand;
        this.zahlung.mwst = this.summeMwst;
        this.zahlung.gesamt = this.summeGesamt;
        this.zahlung.zahler = this.currentBbr;
        this.$store.dispatch("getrankeStand/createGetrankeStand", this.zahlung);
        this.showGetrankeStand = false;
        this.zahlung = [];
      },
      deleteZahlung() {
        this.$store.dispatch("getrankeStand/deleteGetrankeStandeData", this.zahlung.id);
        this.showGetrankeStand = false;
        this.zahlung = [];
        this.showDeleteZahlung = false;
      },
      calcTabelleGetranke() {
        let tabelleGetranke = [];
        this.getranke.forEach((item) => {
          tabelleGetranke.push({
            id: item.id,
            nummer: item.nummer,
            getrank: item,
            bezeichnung: item.text,
            anzahl: "",
          });
        });
        tabelleGetranke = tabelleGetranke.sort(function (a, b) {
          return a.nummer - b.nummer;
        });
        this.tabelleGetranke[0] = tabelleGetranke.slice(0, Math.ceil(tabelleGetranke.length / 4));
        this.tabelleGetranke[1] = tabelleGetranke.slice(
          Math.ceil(tabelleGetranke.length / 4),
          Math.ceil((tabelleGetranke.length / 4) * 2)
        );
        this.tabelleGetranke[2] = tabelleGetranke.slice(
          Math.ceil((tabelleGetranke.length / 4) * 2),
          Math.ceil((tabelleGetranke.length / 4) * 3)
        );
        this.tabelleGetranke[3] = tabelleGetranke.slice(
          Math.ceil((tabelleGetranke.length / 4) * 3),
          tabelleGetranke.length
        );
      },
      savereihenfolge() {
        let nummer = 1;
        this.tabelleGetranke.forEach((value) => {
          value.forEach((item) => {
            let update = {
              id: item.id,
              nummer,
            };
            this.$store.dispatch("getranke/updateGetrankData", update);
            nummer++;
          });
        });
      },
      insertGertranke() {
        this.tabelleGetranke.forEach((value) => {
          value.forEach((item) => {
            if (parseInt(item.anzahl) > 0) {
              this.zahlung.positionen.push({
                id: item.getrank.value.item.id,
                bezeichnung: item.getrank.value.item.bezeichnung,
                anzahl: parseInt(item.anzahl),
                netto: parseFloat(
                  item.getrank.value.item.preis / item.getrank.value.item.verkaufseinheit / 1.19
                ).toFixed(2),
                pfand: parseFloat(
                  (item.getrank.value.item.pfand * item.anzahl) / item.getrank.value.item.verkaufseinheit
                ).toFixed(2),
                summe: parseFloat(
                  (item.getrank.value.item.preis / item.getrank.value.item.verkaufseinheit / 1.19) * item.anzahl
                ).toFixed(2),
              });
              item.anzahl = "";
            }
          });
        });
        this.showSpeedInsert = false;
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// bierwartGetrankeZahlen.vue?4df1e8a3